// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"218":"66784b3e","451":"8aaf82ce","561":"78f947c2","936":"c124c017","945":"04a06dd1"}[chunkId] + ".js";
};